import React from "react";
import Pagination from "react-bootstrap/Pagination";
import { longLeftArrow, longRightArrow } from "../../constants/icons";

const CustomPagination = ({ currentPage, totalPages, onPageChange }) => {
    const getPageItems = () => {
        const items = [];

        if (totalPages <= 7) {
            for (let i = 1; i <= totalPages; i++) {
                items.push(
                    <Pagination.Item key={i} active={i === currentPage} onClick={() => onPageChange(i)}>
                        {i}
                    </Pagination.Item>
                );
            }
        } else {
            items.push(
                <Pagination.Item key={1} active={currentPage === 1} onClick={() => onPageChange(1)}>
                    1
                </Pagination.Item>
            );
            items.push(
                <Pagination.Item key={2} active={currentPage === 2} onClick={() => onPageChange(2)}>
                    2
                </Pagination.Item>
            );
            items.push(
                <Pagination.Item key={3} active={currentPage === 3} onClick={() => onPageChange(3)}>
                    3
                </Pagination.Item>
            );

            if (currentPage >= 4 && currentPage <= 7) {
                for (let i = 4; i <= 7; i++) {
                    items.push(
                        <Pagination.Item key={i} active={i === currentPage} onClick={() => onPageChange(i)}>
                            {i}
                        </Pagination.Item>
                    );
                }
            } else {
                items.push(<Pagination.Ellipsis key="start" disabled />);
            }

            items.push(
                <Pagination.Item key={8} active={currentPage === 8} onClick={() => onPageChange(8)}>
                    8
                </Pagination.Item>
            );
            items.push(
                <Pagination.Item key={9} active={currentPage === 9} onClick={() => onPageChange(9)}>
                    9
                </Pagination.Item>
            );
            items.push(
                <Pagination.Item key={10} active={currentPage === 10} onClick={() => onPageChange(10)}>
                    10
                </Pagination.Item>
            );
        }
        return items;
    };

    return (
        <>
            <span className="page-count">
                Page <span className="page-count-active">{currentPage}</span> of <span className={currentPage === totalPages ? "page-count-active" : ""}>{totalPages}</span>
            </span>
            <Pagination className="custom-pagination">
                <Pagination.Prev onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}>
                    {longLeftArrow}
                </Pagination.Prev>
                {getPageItems()}
                <Pagination.Next onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                    {longRightArrow}
                </Pagination.Next>
            </Pagination>
        </>
    );
};

export default CustomPagination;
